import { getStoreAccessors } from 'typesafe-vuex';
import { IAdminDevicesState } from './state';
import { State } from '../state';
export const mutations = {
    setDevices(state: IAdminDevicesState, payload) {
        state.devices = payload;
    }
};

const { commit } = getStoreAccessors<IAdminDevicesState, State>('');

export const commitSetDevices = commit(mutations.setDevices);